import {
	CreateBase,
	Form,
	Toolbar,
	useGetIdentity,
	useTranslate
} from 'react-admin';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { GoToListButton } from '../../../components/GoToListButton';
import { ICONS_BY_OBJECT, OBJECTS_TYPES } from '../../../constants';
import { CommerceType } from '../../../types';
import { CommerceInputs } from '../CommerceInputs';

export const CommerceCreate = () => {
	const { identity } = useGetIdentity();
	const translate = useTranslate();

	const Icon = ICONS_BY_OBJECT[OBJECTS_TYPES.COMMERCES];

	return (
		<Box mt={3}>
			<GoToListButton />
			<CreateBase
				resource={OBJECTS_TYPES.PROPERTIES}
				redirect={() => `objects/${OBJECTS_TYPES.COMMERCES}`}
				transform={(data): CommerceType => ({
					...data
				})}
			>
				<Box mt={2} display="flex">
					<Box flex="1">
						<Stack mb={1} direction="row" alignItems="center">
							<Icon fontSize="large" />
							<Typography ml={1} variant="h4">
								{translate('objects.items.commerce')}
							</Typography>
						</Stack>
						<Form defaultValues={{ sales_id: identity?.id }}>
							<Card>
								<CardContent>
									<CommerceInputs />
								</CardContent>
								<Toolbar />
							</Card>
						</Form>
					</Box>
				</Box>
			</CreateBase>
		</Box>
	);
};
